import React from 'react';
import { Grid, Row, Col } from '../../utils/bootstrap';
import Colors from '../../Colors';
import Modal from '../../components/Modal';

const styles = {
  subheader: {
    color: Colors.lightBlue,
    fontSize: '2.5rem',
    fontWeight: 'normal',
    marginTop: '.5rem',
    letterSpacing: 0,
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

export default class Template extends React.Component {
  render() {
    const { name, position, description, quote, history } = this.props;
    return (
      <Modal history={history}>
        <Grid className="profile">
          <Row>
            <Col xs={12}>
              <h2 className="title">
                {name}
                <div className="subtitle">{position}</div>
              </h2>
              <br />
              {description}
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1} sm={8} smOffset={2} style={styles.flex}>
              <div className="divider" />
              <h4 className="quote">
                &ldquo;{quote}&rdquo;
              </h4>
            </Col>
          </Row>
        </Grid>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/OurTeam/Template.js